module.exports = __webpack_public_path__ + "media/05.7eb589f2.mp4";